import { useEffect, useState } from 'react'

import BookingPage from './BookingPage'
import _ from 'lodash'
import useQueryParams from '../../hooks/useQueryParams'

const DEFAULT_DAYS = 7

const BookingsWeekView = () => {
  const [numDays, setNumDays] = useState(DEFAULT_DAYS)
  const queryParams = useQueryParams()

  useEffect(() => {
    let days = _.toNumber(queryParams.get('days') ?? DEFAULT_DAYS)
    days = _.isInteger(days) ? days : DEFAULT_DAYS
    setNumDays(days)
  }, [queryParams])

  return <BookingPage numDays={numDays} />
}

export default BookingsWeekView
